export default {
  required: 'This field cannot be empty',
  correct_email: 'Please enter correct email address',
  correct_address: 'Addresse konnte nicht gefunden werden',
}
